import { HttpError } from '@/lib/https';

const readErrorStrings = (error: unknown): string[] => {
  if (error instanceof HttpError) {
    const body = error.error as { message?: unknown; errors?: unknown };
    const fromErrors = Array.isArray(body.errors)
      ? body.errors.filter((entry): entry is string => typeof entry === 'string' && Boolean(entry.trim()))
      : [];
    if (fromErrors.length > 0) return fromErrors;
    if (typeof body.message === 'string' && body.message.trim()) return [body.message.trim()];
    if (error.message.trim()) return [error.message.trim()];
    return [];
  }

  if (error instanceof Error && error.message.trim()) {
    return [error.message.trim()];
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) return [message.trim()];
  }

  return [];
};

const matchesDuplicateKeyText = (text: string): boolean => {
  const normalized = text.toLowerCase();
  return (
    normalized.includes('already exists') ||
    normalized.includes('already in use') ||
    normalized.includes('duplicate')
  );
};

/** Prefer API `errors[]`, then `message`, for display in the attribute form. */
export const getAttributeApiErrorMessage = (error: unknown): string | undefined => {
  const messages = readErrorStrings(error);
  return messages[0];
};

export const isAttributeInUseError = (error: unknown): boolean => {
  if (error instanceof HttpError && error.status === 409) return true;
  if (typeof error === 'object' && error !== null && 'status' in error) {
    const status = (error as { status?: number }).status;
    if (status === 409) return true;
  }
  const message = readErrorStrings(error).join(' ').toLowerCase();
  return message.includes('in use') || message.includes('in-use') || message.includes('cannot delete');
};

export const isDuplicateAttributeKeyError = (error: unknown): boolean =>
  readErrorStrings(error).some(matchesDuplicateKeyText);
